import fetchLocation from "./fetchLocation";
const KEY = 'veer-theme-location-cache-v1';

const save = (data) => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (error) {
    console.warn(error);
  }
};

const get = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(KEY));
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export default async function getLocation() {
  const guideData = get();

  if (guideData) {
    return guideData.data;
  }

  const data = await fetchLocation();

  save({
    data,
  });

  return data;
}
